import { useRef } from 'react';
import ReactGA from 'react-ga4';

import ButtonBase from '@mui/material/ButtonBase';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    reactivateMemberContainer: {
        position: 'absolute',
        top: '56px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        fontSize: '16px',
        fontWeight: 700,
        gap: '10px',
        background: '#7A4406',
        borderRadius: '0 40px 40px 0',
        color: '#FFFFFF',
        cursor: 'pointer',
        marginRight: '20px',
        minWidth: '440px',
        padding: '12px 20px 12px 20%',
        textTransform: 'uppercase',
        '&:hover': {
            background: '#58111a',
            transition: 'background 0.5s ease'
        }
    }
}));

type ReactivateMemberProps = {
    label: 'Request Extension' | 'Extend Membership' | 'Reactivate Membership';
    setShowReactivateMemberOptionsPopup: (value: boolean) => void;
};

const ReactivateMember: React.FC<ReactivateMemberProps> = ({
    label,
    setShowReactivateMemberOptionsPopup
}) => {
    const classes = useStyles();
    const nodeRef = useRef(null);

    const handleReactivateMemberClick = () => {
        ReactGA.event({
            category: 'Holder Profile',
            action: `${label} Click`
        });

        setShowReactivateMemberOptionsPopup(true);
    };

    return (
        <ButtonBase
            ref={nodeRef}
            className={classes.reactivateMemberContainer}
            onClick={handleReactivateMemberClick}
        >
            <span>{label}</span>
            <i className="fas fa-chevron-right" />
        </ButtonBase>
    );
};

export default ReactivateMember;
